import React from 'react';
import Helper from './helper';
import ReactDOM from 'react-dom';
import './css/global.css';
import './css/google-fonts.css';
import Informe from './informe';
import {
	createBrowserRouter,
	RouterProvider,
} from "react-router-dom";
import Header from './components/header/header';
import HomePage from './components/home';
import NewsPage from './components/news';
import Footer from './components/footer/footer';
import News from './components/news';

const router = createBrowserRouter([
{
	path: "/",
	element: <HomePage changePageHandler={(ev) => this.handleChangePage(ev)} />,
},
{
	path: "/nota/:idNota",
	element: <News newsId={"72525103-c646-4f2a-9de3-6c96d1b620a7"} changePageHandler={(ev) => this.handleChangePage(ev)} />,
},
]);


ReactDOM.render(
	<React.StrictMode>
	   	<Header />
		   {/* <NewsPage newsId={"72525103-c646-4f2a-9de3-6c96d1b620a7"} changePageHandler={(ev) => this.handleChangePage(ev)} /> */}
		{/* <Informe newsId={Helper.getDefaultNewsId()} /> */}
		<RouterProvider router={router} />
		<Footer/>
	</React.StrictMode>,
	document.getElementById('root')
);

